import {Datagrid, DateField, FunctionField, Record, TextField} from "react-admin"
import {DatagridPropsWithOptions} from "../../shared/types"
import {IdentifierField} from "../../components/IdentifierField"
import {initField} from "../../shared/utils"
import {ReconciliationFileRowDatagrid} from "./ReconciliationFIleRowDatagrid"
import {DeleteReconciliationFile} from "./DeleteReconciliationFile";


export const ReconciliationFileDatagrid = ({options, ...rest}: DatagridPropsWithOptions) => {
    return options ? (
        <Datagrid
        expand={<ReconciliationFileRowDatagrid/>}
        isRowExpandable={(record) => Number(record.id) > 0}
        >
            <IdentifierField {...initField("id", options)} />
            <FunctionField render={(record:any) => <DeleteReconciliationFile file_id={record.id}/>} label="Elimina" />
            <TextField {...initField("file_name", options)} />
            <DateField {...initField("date", options)} />
            <TextField {...initField("bank__code", options)} label="Banca"/>
            <FunctionField render={function (record?: Record | undefined, source?: string) {
                return record && record.reconciliation_file_row.length
            } } label="Righe"/>
        </Datagrid>
    ) : null
}